module.exports = __webpack_public_path__ + "img/hr.ed38d06d.png";